import { LoadPageAction } from "../../../pillar/common/actions/LoadPageAction";
import { LoadPagePayload } from "../../../pillar/common/actions/LoadPagePayload";

export const GET_EXTRACT_CATEGORY_QUERY = "[Extracts] Get Extracts Query";

export class GetExtractCategoryQueryAction implements LoadPageAction {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_EXTRACT_CATEGORY_QUERY;

  constructor(public payload: LoadPagePayload) {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/GetExtractCategoryQueryAction.ts